import { render, staticRenderFns } from "./selectList.vue?vue&type=template&id=572b1aa8&"
import script from "./selectList.vue?vue&type=script&lang=js&"
export * from "./selectList.vue?vue&type=script&lang=js&"
import style0 from "./selectList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports